<template>
  <div class="d-object-single-genplan__wrapper">
    <div class="d-object-single-genplan__planWrap _desktop">
      <div v-if="premiumAvailable" class="d-object-single-genplan-legend">
        <div class="d-object-single-genplan-legend__item">Бизнес</div>
        <div class="d-object-single-genplan-legend__item">Премиум</div>
      </div>
      <div class="d-object-single-genplan__planInner" :class="genplanData.info.quarter_key === 'ostrov' ? '_ostrov' : ''">
        <div
          ref="genplan"
          class="d-object-single-genplan__plan"
          :style="`height: ${heightPlan}px`"
        >
          <div class="d-object-genplan">
            <d-fitblock
              v-if="genplanData"
              :render="genplanData.render.render"
              auto-scroll
            >
              <template #masks>
                <svg
                  class="d-object-genplan__svg"
                  xmlns="http://www.w3.org/2000/svg"
                  :width="genplanData.render.render.width"
                  :height="genplanData.render.render.height"
                  :viewBox="`0 0 ${genplanData.render.render.width} ${genplanData.render.render.height}`"
                >
                  <path
                    v-for="label in genplanData.labels"
                    :data-label-id="label.id"
                    :key="label.id"
                    class="d-object-genplan__path"
                    :class="{
                      _premium: label.premium,
                      _hover: hoverLabelId === label.id,
                      _hoverSale: label.flats.length < 1,
                      _sale: label.isDone && !label.allowFlats,
                      _done: !label.isDone && !label.allowFlats
                    }"
                    :d="label.points"
                    @click="labelClickHandler(label)"
                  />
                </svg>
              </template>
              <template #labels>
                <div
                  v-for="label in genplanData.labels"
                  :key="label.id"
                  :data-label-id="label.id"
                  :ref="setItemRef"
                  :data-tooltip="JSON.stringify(label)"
                  class="d-object-single-genplan-point"
                  :class="{
                    _hover: hoverLabelId === label.id,
                    _premium: label.premium,
                    _hoverSale: label.flats.length < 1,
                    _sale: label.isDone && !label.allowFlats,
                    _done: !label.isDone && !label.allowFlats
                  }"
                  :style="`left: ${label.position.left}%; top: ${label.position.top}%;`"
                  @click="labelClickHandler(label)"
                  @mouseover="hoverLabel(label.id)"
                  @mouseout="hoverLabelId = null"
                >
                  <div class="d-object-single-genplan-point__name">
                    {{ label.title }}
                  </div>
                  <div
                    v-if="'isDone' in label"
                    class="d-object-single-genplan-point__status"
                    :class="{
                      _disable: !label.allowFlats,
                      _hide: !label.isDone && label.allowFlats > 0,
                    }"
                  >
                    <span v-if="!label.allowFlats && !label.isDone"
                      >Продано</span
                    >
                    <span v-else>Квартал сдан</span>

                    <template v-if="label.isDone">
                      <img
                        v-if="label.allowFlats > 0"
                        src="/assets/blueant/assets/img/icons/key_genplan_white.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="/assets/blueant/assets/img/icons/key_genplan_grey.svg"
                        alt=""
                      />
                    </template>
                  </div>
                </div>
              </template>
            </d-fitblock>
          </div>
        </div>
        <!-- <div
          v-if="currentLabelActive"
          class="d-object-single-genplan-point-info"
          :class="{
            _show: currentLabelActive,
            _premium: currentLabelActive.premium,
          }"
        >
          <div class="d-object-single-genplan-point-info__name">
            {{ currentLabelActive.title }}
          </div>
          <div
            class="d-object-single-genplan-point-info__text"
            v-html="currentLabelActive.text"
          ></div>
          <a
            :href="currentLabelActive.url"
            class="d-object-single-genplan-point-info__btn d-button _dark"
            ><span>Перейти к выбору</span>
          </a>

          <button
            class="d-object-single-genplan-point-info__close"
            @click="closePointInfo"
          >
            <img src="/assets/blueant/assets/img/d/icon_close_pen.svg" />
          </button>
        </div> -->
        <div v-if="!swipeInfoHide" class="d-object-single-genplan__info">
          <div class="d-swipe-info">
            <img src="/assets/blueant/assets/img/d/icon_swipe1.svg" />
            <div>Используйте жесты для прокрутки изображения</div>
            <button @click="closeSwipeInfo(false)">
              <img src="/assets/blueant/assets/img/d/icon_close_pen.svg" />
            </button>
          </div>
        </div>
        <div v-if="genplanData" class="d-object-single-genplan__compass">
          <img
            :src="genplanData?.render.render.compass"
            :style="getCompassAngleStyle"
          />
        </div>
        <d-disclaimer
          v-if="disclaimer"
          class="d-object-single-genplan__disclaimer"
          :text="disclaimer"
        />
      </div>
    </div>
    <div
      v-if="genplanData"
      class="d-object-single-genplan__mobileButton"
      :style="`background-image: url(${genplanData.render.render.img})`"
    >
      <button @click="showPopup = true" class="d-button _white _withImg">
        <img src="/assets/blueant/assets/img/d/icon_pin.svg" />
        <span>Открыть генплан</span>
      </button>
    </div>

    <d-popup-simple v-model="showPopup" name="parkingScheme" mod="scheme">
      <div v-if="showPopup" class="d-object-single-genplan__planWrap">
        <div v-if="premiumAvailable" class="d-object-single-genplan-legend">
          <div class="d-object-single-genplan-legend__item">Бизнес</div>
          <div class="d-object-single-genplan-legend__item">Премиум</div>
        </div>
        <div class="d-object-single-genplan__planInner">
          <div class="d-object-single-genplan__plan">
            <div class="d-object-genplan">
              <d-fitblock
                v-if="genplanData"
                :render="genplanData.render.render"
              >
                <template #masks>
                  <svg
                    class="d-object-genplan__svg"
                    xmlns="http://www.w3.org/2000/svg"
                    :width="genplanData.render.render.width"
                    :height="genplanData.render.render.height"
                    :viewBox="`0 0 ${genplanData.render.render.width} ${genplanData.render.render.height}`"
                  >
                    <path
                      v-for="label in genplanData.labels"
                      :key="label.id"
                      class="d-object-genplan__path"
                      :class="{
                        _premium: label.premium,
                        _hover: hoverLabelId === label.id,
                        _hoverSale: label.flats.length < 1,
                        _sale: label.isDone && !label.allowFlats,
                        _done: !label.isDone && !label.allowFlats
                      }"
                      :d="label.points"
                      @click="labelClickHandler(label)"
                      @mouseover="hoverLabel(label.id)"
                      @mouseout="hoverLabelId = null"
                    />
                  </svg>
                </template>
                <template #labels>
                  <div
                    v-for="label in genplanData.labels"
                    :key="label.id"
                    class="d-object-single-genplan-point"
                    :class="{
                      _hover: hoverLabelId === label.id,
                      _premium: label.premium,
                      _hoverSale: label.flats.length < 1,
                      _sale: label.isDone && !label.allowFlats,
                      _done: !label.isDone && !label.allowFlats
                    }"
                    :style="`left: ${label.position.left}%; top: ${label.position.top}%;`"
                    @click="labelClickHandler(label)"
                    @mouseover="hoverLabel(label.id)"
                    @mouseout="hoverLabelId = null"
                  >
                    <div class="d-object-single-genplan-point__name">
                      {{ label.title }}
                    </div>
                    <div
                      v-if="label.text"
                      class="d-object-single-genplan-point__text"
                      v-html="label.text"
                    ></div>
                    <div
                      v-if="'isDone' in label"
                      class="d-object-single-genplan-point__status"
                      :class="{
                        _disable: !label.allowFlats,
                        _hide: !label.isDone && label.allowFlats > 0,
                      }"
                    >
                      <span v-if="!label.allowFlats && !label.isDone"
                        >Продано</span
                      >
                      <span v-else>Квартал сдан</span>

                      <template v-if="label.isDone">
                        <img
                          v-if="label.allowFlats > 0"
                          src="/assets/blueant/assets/img/icons/key_genplan_white.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="/assets/blueant/assets/img/icons/key_genplan_grey.svg"
                          alt=""
                        />
                      </template>
                    </div>
                  </div>
                </template>
              </d-fitblock>
            </div>
          </div>
          <!-- <div
            v-if="currentLabelActive"
            class="d-object-single-genplan-point-info"
            :class="{
              _show: currentLabelActive,
              _premium: currentLabelActive.premium,
            }"
          >
            <div class="d-object-single-genplan-point-info__name">
              {{ currentLabelActive.title }}
            </div>
            <div
              class="d-object-single-genplan-point-info__text"
              v-html="currentLabelActive.text"
            ></div>
            <a
              :href="currentLabelActive.url"
              class="d-object-single-genplan-point-info__btn d-button _dark"
              ><span>Перейти к выбору</span>
            </a>

            <button
              class="d-object-single-genplan-point-info__close"
              @click="closePointInfo"
            >
              <img src="/assets/blueant/assets/img/d/icon_close_pen.svg" />
            </button>
          </div> -->
          <div
            v-if="!swipeInfoHideMobile"
            class="d-object-single-genplan__info"
          >
            <div class="d-swipe-info">
              <img src="/assets/blueant/assets/img/d/icon_swipe1.svg" />
              <div>Используйте жесты для прокрутки изображения</div>
              <button @click="closeSwipeInfo(true)">
                <img src="/assets/blueant/assets/img/d/icon_close_pen.svg" />
              </button>
            </div>
          </div>
          <div v-if="genplanData" class="d-object-single-genplan__compass">
            <img
              :src="genplanData?.render.render.compass"
              :style="getCompassAngleStyle"
            />
          </div>

          <d-disclaimer
            v-if="disclaimer"
            class="d-object-single-genplan__disclaimer"
            :text="disclaimer"
          />
        </div>
      </div>
    </d-popup-simple>
    <d-popup-simple v-if="currentLabelActive" v-model="quarterMobilePopupShow" mod="center">
      <div class="d-builds-info">
        <div v-if="currentLabelActive.isQuarter" class="d-builds-info__title">Квартал {{ currentLabelActive.title }}</div>
        <div v-else class="d-builds-info__title">{{ currentLabelActive.title }}</div>
        <!-- <div v-if="currentLabelActive.buildings" class="d-builds-info__numbers">Корпуса: {{ currentLabelActive.buildings }}</div> -->
        <div v-if="currentLabelActive.buildingDetails" class="d-builds-info__numbers">
          <template v-if="currentLabelActive.buildingDetails.some(building => building.is_done)">
            <div class="d-visual-building-info__statusImage">
              <img src="/assets/blueant/assets/img/icons/key_genplan_white.svg" alt="">
            </div>
            Корпуса {{ currentLabelActive.buildingDetails
              .filter(building => building.is_done)
              .map(building => building.num)
              .join(', ') }} сданы
          </template>
        </div>
        <div class="d-builds-info__about" v-html="currentLabelActive.text"></div>
        <div v-if="currentLabelActive.flats.length > 0" class="d-builds-info__facts">
          <div v-if="currentLabelActive.buildCount" class="d-builds-info__factsItem">
            <div class="d-builds-info__factsValue">{{ currentLabelActive.buildCount }}</div>
            <div class="d-builds-info__factsLabel">корпусов</div>
          </div>
          <div class="d-builds-info__factsItem">
            <div class="d-builds-info__factsValue">{{ currentLabelActive.floors[0] }}-{{ currentLabelActive.floors[1] }}</div>
            <div class="d-builds-info__factsLabel">этажей</div>
          </div>
          <div class="d-builds-info__factsItem">
            <div class="d-builds-info__factsValue">{{ currentLabelActive.allowFlats }}</div>
            <div class="d-builds-info__factsLabel">свободных квартир</div>
          </div>
          <div class="d-builds-info__factsItem">
            <div class="d-builds-info__factsValue">{{ currentLabelActive.areas[0] }}-{{ currentLabelActive.areas[1] }}</div>
            <div class="d-builds-info__factsLabel">площадь,&nbsp;м&sup2;</div>
          </div>
        </div>
        <div class="d-builds-info__flats" :class="{_long: currentLabelActive.flats.length > 6}">
          <div v-if="currentLabelActive.flats.length > 0" v-for="flat in currentLabelActive.flats" :key="flat.rooms" class="d-builds-info__flat">
            <div class="d-builds-info__flatLabel">{{ flat.rooms === 0 ? 'Студии' : `${ flat.rooms }-комн.` }}</div>
            <div v-if="flat.price_request && flat.price_request_label" class="d-builds-info__flatValue">{{ flat.price_request_label }}</div>
            <div v-else class="d-builds-info__flatValue">от {{ flat.priceMin }} млн ₽</div>
          </div>
          <div v-else class="d-builds-info__facts"><p class="_empty">Все квартиры проданы</p></div>
        </div>
        <div v-if="currentLabelActive.flats.length > 0" class="d-builds-info__bottom">
          <a class="d-builds-info__button d-button _dark" :href="linkPopupToBuilding(currentLabelActive.url)"><span>Выбрать квартиру</span></a>
        </div>
      </div>
    </d-popup-simple>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import DFitblock from "../molecules/DFitblock.vue";
import DPopupSimple from "../molecules/DPopupSimple.vue";
import tippy from "tippy.js";
import setPlanHeight from "@utils/setPlanHeight";
import DDisclaimer from "@components/atoms/DDisclaimer.vue";
import { addWebpUrlParam } from "@utils/getSupportWebp";

export default {
  name: "DGenplanObject",
  props: {
    genplanApiUrl: {
      type: String,
      default: "",
    },
  },
  components: {
    DFitblock,
    DPopupSimple,
    DDisclaimer,
  },
  data() {
    return {
      genplanData: null,
      hoverLabelId: null,
      currentLabelActive: null,
      swipeInfoHide: null,
      swipeInfoHideMobile: null,
      quarterMobilePopupShow: false,
      showPopup: false,
      itemRefs: [],
      heightPlan: null,
    };
  },
  computed: {
    isTouchDevice() {
      if (window.PointerEvent && "maxTouchPoints" in navigator) {
        if (navigator.maxTouchPoints > 0) {
          return true;
        }
      } else {
        if (
          window.matchMedia &&
          window.matchMedia("(any-pointer:coarse)").matches
        ) {
          return true;
        } else if (window.TouchEvent || "ontouchstart" in window) {
          return true;
        }
      }
      return false;
    },
    premiumAvailable() {
      if (!this.genplanData) {
        return null;
      }
      return this.genplanData.labels.find((label) => {
        return label.premium;
      });
    },
    disclaimer() {
      if (!this.genplanData) return null;
      else return this.genplanData.info.disclaimer;
    },
    getCompassAngleStyle() {
      if (!this.genplanData || !this.genplanData.render.render.compass_angle)
        return "";
      return {
        transform: `rotate(${this.genplanData.render.render.compass_angle}deg)`,
      };
    },
  },
  created() {
    this.getData();
  },
  beforeUpdate() {
    this.itemRefs = [];
  },
  updated() {
    this.itemRefs.forEach((item) => {
      this.createTooltip(item);
    });
  },
  mounted() {
    this.swipeInfoHide = Number(Cookies.get("closedSwipeInfo")) === 1;
    this.swipeInfoHideMobile =
      Number(Cookies.get("closedSwipeInfoMobile")) === 1;

    this.$nextTick(() => {
      this.heightPlan = setPlanHeight(this.$refs.genplan);
      window.addEventListener("resize", this.setHeightPlan);
    });
  },
  methods: {
    async getData() {
      try {
        let response = await this.axios.get(
          await addWebpUrlParam(this.genplanApiUrl)
        );

        this.genplanData = response.data;
      } catch (err) {
        console.error("error load genplan data", err);
      }
    },
    labelClickHandler(label) {
      if(label.flats.length < 1) return
      if (this.isTouchDevice) {
        this.currentLabelActive = label;
        this.hoverLabelId = label.id;
        this.quarterMobilePopupShow = true;
      } else if (label.url && label.url !== "#") {
        window.location = label.url;
      }
    },
    closePointInfo() {
      this.hoverLabelId = null;
      this.currentLabelActive = null;
    },
    hoverLabel(id) {
      this.hoverLabelId = id;
    },
    closeSwipeInfo(mobile = false) {
      if (mobile) {
        Cookies.set("closedSwipeInfoMobile", 1);
        this.swipeInfoHideMobile = true;
      } else {
        Cookies.set("closedSwipeInfo", 1);
        this.swipeInfoHide = true;
      }
    },
    setItemRef(el) {
      if (el) {
        this.itemRefs.push(el);
      }
    },
    createTooltip(target) {
      const data = JSON.parse(target.dataset.tooltip);

      console.log('data', data);


      let tplFlats = ``;
      let tpl = '<div class="d-builds-info">';


      if (data.flats && Array.isArray(data.flats)) {
        data.flats.forEach((flat) => {
          tplFlats +=
            `
          <div class="d-builds-info__flat">
            <div class="d-builds-info__flatLabel">${
              flat.rooms === 0 ? "Студии" : `${flat.rooms}-комн.`
            } </div>` +
            (flat.price_request && flat.price_request_label
              ? `<div class="d-builds-info__flatValue">${flat.price_request_label}</div>`
              : data.allowFlats > 1
              ? `<div class="d-builds-info__flatValue">от ${flat.priceMin} млн ₽</div>`
              : `<div class="d-builds-info__flatValue">${flat.priceMin} млн ₽</div>`) +
            `</div>
        `;
        });


        if (data.isQuarter) {
          tpl += `<div class="d-builds-info__title">Квартал ${data.title}</div>`;
        } else tpl += `<div class="d-builds-info__title">${data.title}</div>`;

        // if (data.buildings) {
        //   tpl += `<div class="d-builds-info__numbers">Корпуса: ${data.buildings}</div>`;
        // }

        if (data.buildingDetails) {
          // Фильтруем массив, оставляем только корпуса с is_done: true
          const doneBuildings = data.buildingDetails
            .filter(building => building.is_done)
            .map(building => building.num)
            .join(', ');

          if (doneBuildings) {
            tpl += `<div class="d-builds-info__numbers">
              <div class="d-visual-building-info__statusImage">
                <img src="/assets/blueant/assets/img/icons/key_genplan_white.svg" alt="">
              </div>
              Корпуса ${doneBuildings} сданы
              </div>`;
          }
        }

        tpl += `
          <div class="d-builds-info__about">
            ${data.text}
          </div>`;

              if (data.allowFlats && data.buildCount) {
                tpl += `
          <div class="d-builds-info__facts">
            <div class="d-builds-info__factsItem">
              <div class="d-builds-info__factsValue">${data.buildCount}</div>
              <div class="d-builds-info__factsLabel">корпусов</div>
            </div>`;
              } else if (data.allowFlats) {
                tpl += `
          <div class="d-builds-info__facts">`;
              } else
                tpl += `
          <div class="d-builds-info__facts"><p class="_empty">Все квартиры проданы</p></div>
        </div>`;

              if (data.allowFlats)
                tpl += `
            <div class="d-builds-info__factsItem">
              <div class="d-builds-info__factsValue">${data.floors[0]}-${
                  data.floors[1]
                }</div>
              <div class="d-builds-info__factsLabel">этажей</div>
            </div>
            <div class="d-builds-info__factsItem">
              <div class="d-builds-info__factsValue">${data.allowFlats}</div>
              <div class="d-builds-info__factsLabel">свободных квартир</div>
            </div>
            <div class="d-builds-info__factsItem">
              <div class="d-builds-info__factsValue">${data.areas[0]}-${
                  data.areas[1]
                }</div>
              <div class="d-builds-info__factsLabel">площадь,&nbsp;м&sup2;</div>
            </div>
          </div>
          <div class="d-builds-info__flats${data.flats.length > 6 ? " _long" : ""}">
              ${tplFlats}
          </div>

        </div>
      `;
      }
      const labelId = target.dataset.labelId;
      const secondTarget = document.querySelector(
        `.d-object-genplan__path[data-label-id="${labelId}"]`
      );

        tippy(target, {
          // trigger: 'click',
          allowHTML: true,
          // appendTo: () => this.$refs.genplan,
          offset: [0, 8],
          theme: 'visual-quarter',
          placement: 'left-end',
          animation: 'fade',
          content: tpl,
          arrow: false,
          touch: false,
          triggerTarget: [secondTarget, target],
        });
    },
    setHeightPlan() {
      this.heightPlan = setPlanHeight(this.$refs.genplan);
    },
    linkPopupToBuilding(url) {
      const typeParam = url.includes('?type')
      return typeParam ? url : `${url}?type=${this.type}`;
    }
    // getCompassAngleStyle(deg) {
    //   console.log('deg', deg)
    //   if (!deg) return ''
    //   return `transform: rotate(${deg}px)`
    // }
  },
};
</script>

<style scoped></style>
